export default __webpack_public_path__ + "static/media/shadab.59689ab5.jpg";